import React from "react";
import {useTranslation} from "react-i18next";
import {ExclamationTriangleIcon} from "@heroicons/react/16/solid";

export interface ConfiguratorDeleteStateProps {
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfiguratorDeleteState = ({onConfirm, onCancel}: ConfiguratorDeleteStateProps) => {
    const {t} = useTranslation();
    return (
        <div className="mt-8 mb-8 rounded-lg border-2 p-4 border-dashed border-gray-300 hover:border-gray-400">
            <div className="sm:flex sm:items-start">
                <div
                    className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                    <ExclamationTriangleIcon aria-hidden="true" className="size-6 text-red-600"/>
                </div>
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <h3 className="text-base font-semibold text-gray-900">
                        {t('CONFIG.APPROVE_DELETE')}
                    </h3>
                    <div className="mt-2">
                        <p className="text-sm text-gray-500">
                            {t('CONFIG.DESCRIPTION_DELETE')}
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-5 sm:ml-10 sm:mt-4 sm:flex sm:pl-4">
                <button
                    type="button"
                    onClick={() => onConfirm()}
                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:w-auto"
                >
                    {t('BUTTON.REMOVE')}
                </button>
                <button
                    type="button"
                    data-autofocus
                    onClick={() => onCancel()}
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:ml-3 sm:mt-0 sm:w-auto"
                >
                    {t('BUTTON.CANCEL')}
                </button>
            </div>
        </div>
    )
}